import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { type ComponentProps } from 'react';

import { Logo } from '../../Logo/Logo';
import { ReactComponent as TurkeyPilgrimLogoIcon } from './TurkeyPilgrimLogo.svg';

export const ThanksgivingLogo = observer(function ThanksgivingLogo(props: ComponentProps<typeof Logo>) {
	return (
		<Tooltip
			{...{
				title: 'Happy Thanksgiving!',
				placement: 'right',
				children: <Logo {...{ children: <TurkeyPilgrimLogoIcon />, ...props }} />,
			}}
		/>
	);
});
